import moment, { Moment } from "moment-timezone";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function useCalendarViewDate() {
  const { i18n } = useTranslation();

  const [viewingDate, setViewingDate] = useState<Moment>(
    moment().locale(i18n.language)
  );

  const onChangeViewingDate = (date: Moment) => {
    setViewingDate(date);
  };

  useEffect(() => {
    onChangeViewingDate(moment().locale(i18n.language));
  }, [i18n.language]);

  return { viewingDate, onChangeViewingDate };
}
